export default __webpack_public_path__ + "static/media/pg-21.d307592e.jpg";